import React,{useState} from 'react';
import { useSelector } from 'react-redux';
import { selectUserData } from '../../reducers/user.reducer';
import UpdateResult from './UpdateResult';

const Index = () => {
    const {companyList} = useSelector(selectUserData);
    const [activeTitle,setActiveTitle] = useState(companyList[0]?.companyId);
    const [apis,setApis] = useState(companyList[0]?.apis);

    const handleChange = (data) => {
        setApis(data.apis);
        setActiveTitle(data.companyId)
    }

  return (
      <div>
          <div className='flex justify-center items-center cursor-pointer mt-1'>
            {/* {
                companyList.length > 1 ?
                companyList && companyList.map((el,i) => {
                    return (
                        <span key={i} className={`mr-1 text-[0.88rem] font-semibold p-2 ${activeTitle === el.companyId ? 'bg-slate-300 rounded-md transition-all' : null}`} onClick={()=>handleChange(el)}>{el.companyName}</span>
                    )
                }) : null
            } */}
              {/* <span className={`mr-1 text-[0.88rem] font-semibold p-2 ${activeTitle === 'Sport909' ? 'bg-slate-300 rounded-md transition-all' : null}`} onClick={()=>setActiveTitle('Sport909')}>Sport909</span>
              <span className={`ml-1 text-[0.88rem] font-semibold p-2 ${activeTitle === 'LuckySeven' ? 'bg-slate-300 rounded-md transition-all' : null}`} onClick={()=>setActiveTitle('LuckySeven')}>Lucky Seven</span> */}
          </div>
              <UpdateResult activeTitle={activeTitle} apis={apis}/> 
      </div>
  )
}

export default Index;